import React from 'react';
import {Table} from "antd";
import style from './index.module.css';

const CertificationScope = () => {
    const columns = [
        {
            title: '认证类别',
            dataIndex: 'certificationType',
            key: 'certificationType',
        },
        {
            title: '认证领域',
            dataIndex: 'certificationScope',
            key: 'certificationScope',
        },
    ];

    const data = [
        {
            key: '1',
            certificationType: '产品认证',
            certificationScope: 'PV15 蓄电池、原电池、原电池组和其他电池及其零件',
        },
    ]

    return (
        <div>
            <div className={style.title}>可以受理的认证业务范围</div>
            <Table className={style.bigFontTable} style={{height: '500px', width: "100%", marginTop: "20px"}}
                   columns={columns} dataSource={data} pagination={false}/>
        </div>
    );
};

export default CertificationScope;